var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"number-font"},[_vm._v(_vm._s(_vm.chargeDisplay))])
}
var staticRenderFns = []

export { render, staticRenderFns }